// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2glfm","checkboxCol":"Table_checkboxCol__2QpxD","emailCol":"Table_emailCol__2Hq5O","actionCol":"Table_actionCol__13zf5"};